import React, { useEffect, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { Editor } from "@tinymce/tinymce-react";
import { buildSubmitMessageTinyMceInit } from "./addFormSubmitMessageEditorInit";

const AddFormSubmitMessageSection = ({
  submitMessageLoading,
  submit_message,
  handleEditorInit,
  handleFileChange,
}) => {
  const editorInit = useMemo(() => buildSubmitMessageTinyMceInit(handleFileChange), [handleFileChange]);

  useEffect(() => {
    if (!submitMessageLoading) return undefined;
    const id = toast.loading(
      "Please wait while we process your media...",
      {
        position: "top-center",
        style: {
          backgroundColor: "#1471B0",
          color: "#fff",
          width: "380px",
        },
      }
    );
    return () => toast.dismiss(id);
  }, [submitMessageLoading]);

  return (
    <Row className="mt-lg-3 mt-sm-3 mx-4">
      <Col xs={12} sm={12} lg={12}>
        <label className="itemText lable mt-2 C-dark form-label">
          Submit Message
        </label>
        <Editor
          tinymceScriptSrc="/path/to/tinymce.min.js"
          initialValue={submit_message}
          onInit={handleEditorInit}
          init={editorInit}
        />
      </Col>
    </Row>
  );
};

export default AddFormSubmitMessageSection;
